import React from "react";
import { Button, Tooltip } from "antd";
import { FileTextOutlined } from "@ant-design/icons";

export const ProposalExportButton: React.FC<{
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: string;
}> = ({ onClick, disabled, disabledReason }) => {
  const button = (
    <Button
      disabled={disabled}
      icon={<FileTextOutlined />}
      type="primary"
      size="small"
      onClick={onClick}
    >
      Proposal
    </Button>
  );

  return disabled ? <Tooltip title={disabledReason}>{button}</Tooltip> : <>{button}</>;
};
